var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-text-content",domProps:{"innerHTML":_vm._s(_vm.answers.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }